import { Shop } from 'models/Shop';
import React, { useRef } from 'react';
import {
  CardHeader as CardHeaderStyled,
  HeadingName,
  LogoWrapper
} from './CardHeader.styles';
import { openLinkInNewTabViaJs } from 'helpers/openLinksViaJs';
import { appendEmbedToExternalHref } from 'helpers/externalUrl';
import { MemberProfileBadge } from 'components/Illustrations/MemberProfileBadge/MemberProfileBadge';
import { FreeAccountProfileBadge } from 'components/Illustrations/FreeAccountProfileBadge/FreeAccountProfileBadge';
import { Tooltip } from '@trustedshops/tps-seo-shared-frontend-react-components';
import VerificationTooltipContent from 'components/ShopResultItem/VerificationTooltipContent/VerificationTooltipContent';

const CardHeader = ({
  shop,
  isSingleElement,
  embed
}: {
  shop: Shop;
  isSingleElement: boolean;
  embed?: boolean;
}) => {
  const classNames = ['shopImage'];
  /* istanbul ignore next */
  if (shop.shopUrl) {
    classNames.push('clickable');
  }

  const refForTooltip = useRef<HTMLSpanElement>(null);

  /* istanbul ignore next */
  function onTooltipWrapperClick(e: React.MouseEvent) {
    e.preventDefault();
  }

  return (
    <CardHeaderStyled $isSingleElement={isSingleElement}>
      <HeadingName as="h3" $lookAlike="h3">
        {shop.shopName}
        {shop.profileType !== 'non-member' && (
          <>
            <div onClick={onTooltipWrapperClick}>
              <Tooltip
                childrenRef={refForTooltip}
                uniqueId={'profile-type'}
                backgroundColor={'#1D2939'}
                content={<VerificationTooltipContent shop={shop} />}
                placement={'bottom'}
                maxWidthMobile={'218px'}
                maxWidthDesktop={'236px'}
              >
                <span ref={refForTooltip}>
                  {shop.profileType === 'member' && <MemberProfileBadge />}
                  {shop.profileType === 'free-account' && (
                    <FreeAccountProfileBadge />
                  )}
                </span>
              </Tooltip>
            </div>
          </>
        )}
      </HeadingName>
      {shop.shopLogoUrl && (
        <LogoWrapper>
          <img
            onClick={
              /* istanbul ignore next */
              shop.shopUrl
                ? (e) =>
                    openLinkInNewTabViaJs(
                      e,
                      appendEmbedToExternalHref(shop.shopUrl, embed)
                    )
                : undefined
            }
            src={shop.shopLogoUrl}
            alt={shop.shopName}
            className={classNames.join(' ')}
            loading="lazy"
          />
        </LogoWrapper>
      )}
    </CardHeaderStyled>
  );
};

export default CardHeader;
